import React from "react";
import { Helmet } from "react-helmet";

const IFrameResize = ({ IFrameHeight }) => {
    return (
        <Helmet>
            <script key="function" id="iframe-resize-script">
                {
                    `
                    let previousHeight = 0;
                    function sendHeight(){
                      var alturaIframe = document.documentElement.scrollHeight;
                      if (Math.abs(alturaIframe - previousHeight) > 60) {
                        window.parent.postMessage(JSON.stringify({
                          "height": (alturaIframe + 30) + "px",
                          "url":"${process.env.REACT_APP_DOMAIN + window.location.pathname}"
                          }),"*");
                        previousHeight = alturaIframe;
                      }
                    }
                    window.setInterval(sendHeight,500);
                    sendHeight();
                    `
                }
            </script>
        </Helmet>
    );
};

export default IFrameResize;